import { defineStyleConfig } from "@chakra-ui/styled-system";
import { layerStyles } from "theme/layer-styles";

export const textareaTheme = defineStyleConfig({
  variants: {
    outline: {
      ...layerStyles["input-container"],
    },
  },
  sizes: {
    md: {
      px: "2.5",
    },
  },
});
